/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_MemoryInputs */

const en_mk_shot_memory = /** @type {(inputs: Mk_Shot_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company memory page holding tone-of-voice rules, forbidden words, product prices and internal process notes.`)
};

const id_mk_shot_memory = /** @type {(inputs: Mk_Shot_MemoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Memori perusahaan berisi aturan nada bicara, kata terlarang, harga produk, dan proses internal.`)
};

/**
* | output |
* | --- |
* | "The Company memory page holding tone-of-voice rules, forbidden words, product prices and internal process notes." |
*
* @param {Mk_Shot_MemoryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_memory = /** @type {((inputs?: Mk_Shot_MemoryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_MemoryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_memory(inputs)
	return en_mk_shot_memory(inputs)
});